import type { FC } from 'react';
import React from 'react';

export type CommentsSectionProps = {
	contentId: string;
	classicComments: React.ComponentType<any> | undefined;
	handlePageCommentsRender?: () => void;
};

export const CommentsSection: FC<CommentsSectionProps> = ({
	contentId,
	classicComments,
	handlePageCommentsRender,
}) => {
	return classicComments
		? React.createElement(classicComments, {
				contentId,
				handlePageCommentsRender,
			})
		: null;
};
